import { render, staticRenderFns } from "./DataReportAccesoPlataforma.vue?vue&type=template&id=d643bc96"
import script from "./DataReportAccesoPlataforma.vue?vue&type=script&lang=js"
export * from "./DataReportAccesoPlataforma.vue?vue&type=script&lang=js"
import style0 from "./DataReportAccesoPlataforma.vue?vue&type=style&index=0&id=d643bc96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports